import Button from 'Components/Atoms/Button/Button';
import Alert from 'Components/Molecules/Alert/Alert';
import trialAlertImage from 'assets/trial-alert.svg';
import OutlineAutomation from 'Components/Atoms/OutlineIcons/OutlineAutomation';
import OutlineVideo from 'Components/Atoms/OutlineIcons/OutlineVideo';
import BookDemoDialog from 'Components/Organisms/DialogBookDemo/DialogBookDemo';
import { useEffect, useState } from 'react';
import usePlansAndPricingDialog from 'Hooks/usePlansAndPricingDialog';
import useProjectSelected from 'Hooks/useProjectSelected';
import useProvidersConnections from 'Hooks/useProvidersConnections';
import { differenceInCalendarDays } from 'date-fns';
import { useTranslation } from 'react-i18next';

export default function AppLayoutNoticesTrial() {
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const { openPlansAndPricing } = usePlansAndPricingDialog();
    const [daysLeft, setDaysLeft] = useState(null);
    const { project, isLoading } = useProjectSelected();
    const { fakeProviders, isLoading: isLoadingFakeProviders } = useProvidersConnections();
    const { t } = useTranslation('common');

    const hasFakeProviders = fakeProviders.length > 0;
    const isSingleSociety = project?.societies_count === 'single';
    const isSmallCompany = ['only_one', 'one_to_five'].includes(project?.company_size);
    const shouldShowCallButton = isSingleSociety && isSmallCompany;

    useEffect(() => {
        if (isLoading) {
            return;
        }

        if (!project?.subscription) {
            return;
        }

        if (project?.subscription.is_trial) {
            const expirationDate = project.subscription.expiration_datetime;
            const today = new Date();
            const daysLeft = differenceInCalendarDays(expirationDate, today);
            const normalizedDaysLeft = isNaN(daysLeft) ? 0 : Math.max(daysLeft, 0);

            setDaysLeft(normalizedDaysLeft);
        }
    }, [project?.subscription, isLoading]);

    const handleNavigateToPlans = () => {
        openPlansAndPricing();
    };

    const description = hasFakeProviders
        ? t('connect-a-bank-to-see-your-real-data')
        : t('choose-a-plan-before-your-trial-ends');

    if (isLoading || isLoadingFakeProviders) {
        return null;
    }

    if (!project?.subscription?.is_trial) {
        return null;
    }

    return (
        <>
            <BookDemoDialog open={isDialogOpen} onClose={() => setIsDialogOpen(false)} />

            <Alert
                variant="primary"
                title={t('days-left-of-the-trial-period', { count: daysLeft })}
                description={description}
                icon={<img src={trialAlertImage} alt="" />}
                actions={[
                    shouldShowCallButton ? (
                        <Button key="call" variant="primary" as="a" href="tel:+34936289393">
                            {t('call-us')}
                        </Button>
                    ) : (
                        <Button key="demo" variant="primary" onClick={() => setIsDialogOpen(true)}>
                            <OutlineVideo />
                            {t('request-demo')}
                        </Button>
                    ),
                    <Button key="plans" className="border-0" onClick={handleNavigateToPlans}>
                        <OutlineAutomation />
                        {t('view-plans')}
                    </Button>,
                ]}
            />
        </>
    );
}
